import { ReactNode } from 'react';

import { QuickSignModal } from '../components/forms/quick-sign/quick-sign-modal';
import { SignatureFormType } from '../enums/signature-form-type.const';

export type SignatureFormTypeComponentMap = Record<SignatureFormType, ReactNode>;

export const signatureFormTypeComponentMap: SignatureFormTypeComponentMap = {
  [SignatureFormType.QUICK_SIGN]: <QuickSignModal />,
};
